export enum PriceType {
  FIXED = "Fixed",
  FROM = "From",
  HIDE = "Hide",
  OFFERS = "Offers",
}
